// // // import React, { useState, useEffect, useRef } from 'react';
// // // import Sidebar from '../Sidebar/Sidebar';
// // // import { useNavigate } from 'react-router-dom';
// // // import styles from './Dashboard.module.css';
// // // import { useLocation } from "react-router-dom";
// // // import OverviewTab from "../Components/OverviewTab";


// // // const LandingPage = () => {
// // //   const [sidebarOpen, setSidebarOpen] = useState(false);
// // //   const [isMobile, setIsMobile] = useState(false);
// // //   const canvasRef = useRef(null);
// // //   const navigate = useNavigate();

// // //   const location = useLocation();

// // // const activeTab = location.state?.activeTab || "landing";

// // //   useEffect(() => {
// // //     const checkMobile = () => {
// // //       const mobile = window.innerWidth < 1024;
// // //       setIsMobile(mobile);
// // //       setSidebarOpen(!mobile);
// // //     };
// // //     checkMobile();
// // //     window.addEventListener('resize', checkMobile);
// // //     return () => window.removeEventListener('resize', checkMobile);
// // //   }, []);

// // //   useEffect(() => {
// // //     const canvas = canvasRef.current;
// // //     const ctx = canvas.getContext('2d');
// // //     let animationFrameId;

// // //     const resizeCanvas = () => {
// // //       canvas.width = window.innerWidth;
// // //       canvas.height = window.innerHeight;
// // //     };
// // //     resizeCanvas();
// // //     window.addEventListener('resize', resizeCanvas);

// // //     const drawDots = () => {
// // //       ctx.clearRect(0, 0, canvas.width, canvas.height);
// // //       const spacing = 30;
// // //       for (let x = 0; x < canvas.width; x += spacing) {
// // //         for (let y = 0; y < canvas.height; y += spacing) {
// // //           ctx.beginPath();
// // //           ctx.arc(x, y, 1.5, 0, 2 * Math.PI);
// // //           ctx.fillStyle = 'rgba(255, 255, 255, 0.1)';
// // //           ctx.fill();
// // //         }
// // //       }
// // //       animationFrameId = requestAnimationFrame(drawDots);
// // //     };

// // //     drawDots();

// // //     return () => {
// // //       cancelAnimationFrame(animationFrameId);
// // //       window.removeEventListener('resize', resizeCanvas);
// // //     };
// // //   }, []);

// // //   const handleSidebarEnter = () => {
// // //     if (!isMobile) setSidebarOpen(true);
// // //   };

// // //   const handleSidebarLeave = () => {
// // //     if (!isMobile) setSidebarOpen(false);
// // //   };

// // // const handleGetStartedClick = () => {
// // //   setSidebarOpen(true);
// // //   // navigate('/get-started');
// // // };

// // //   return (
// // //     <div className={styles.dashboardContainer}>
// // //       <Sidebar
// // //         isOpen={sidebarOpen}
// // //         toggleSidebar={() => setSidebarOpen(prev => !prev)}
// // //         onMouseEnter={handleSidebarEnter}
// // //         onMouseLeave={handleSidebarLeave}
// // //       />

// // //       <main
// // //         className={styles.mainContent}
// // //         style={{
// // //           marginLeft: sidebarOpen ? '280px' : '80px',
// // //         }}
// // //       >
// // //         {/* Dot grid background inline */}
// // //         <canvas
// // //           ref={canvasRef}
// // //           style={{
// // //             position: 'absolute',
// // //             inset: 0,
// // //             width: '100%',
// // //             height: '100%',
// // //             pointerEvents: 'none',
// // //             zIndex: 0,
// // //           }}
// // //         />

// // //         <div className={styles.landingPage}>
// // //           {/* LEFT CONTENT */}
// // // <div className={styles.leftContent}>
// // //   <div className={styles.titleContainer}>
// // //     <h1 className={styles.mainTitle}>
// // //       {'Welcome to Skillora'.split('').map((letter, index) => (
// // //         <span key={index} className={styles.letter}>
// // //           <span className={styles.glitchLayer}>{letter}</span>
// // //           <span className={styles.glitchLayer}>{letter}</span>
// // //           <span className={styles.letterInner}>
// // //             {letter === ' ' ? '\u00A0' : letter}
// // //           </span>
// // //         </span>
// // //       ))}
// // //     </h1>
// // //   </div>

// // //   <div className={styles.subtitle}>
// // //     <p className="mb-5">
// // //       <span className={styles.waveIcon}>🎯</span>
// // //       <span className={styles.waveText}>Revolutionizing</span>
// // //       <span className={styles.waveText}>Skill</span>
// // //       <span className={styles.waveText}>Assessment</span>
// // //     </p>
// // //   </div>

// // //   <button
// // //     className={styles.getStartedButton}
// // //     onClick={handleGetStartedClick}
// // //   >
// // //     <span className={styles.buttonText}>Get Started →</span>
// // //     <div className={styles.buttonBackground}></div>
// // //     <div className={styles.buttonBorder}></div>
// // //   </button>
// // // </div>

// // // {/* RIGHT CONTENT */}
// // // <div className={styles.rightContent}>
// // //   <div className={styles.imageContainer}>
// // //     <img
// // //       src="/images/Interview.jpg"
// // //       alt="Skill Assessment Interview"
// // //       className={styles.mainImage}
// // //     />
// // //     <div className={styles.imageOverlay}></div>
// // //     <div className={styles.floatingElement1}>⭐</div>
// // //     <div className={styles.floatingElement2}>💡</div>
// // //     <div className={styles.glowRing}></div>
// // //   </div>
// // // </div>
// // //         </div>
// // //       </main>
// // //     </div>
// // //   );
// // // };

// // // export default LandingPage;



// // import React, { useState, useEffect, useRef } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import Sidebar from '../Sidebar/Sidebar';
// // import OverviewTab from '../../Manager/NewDashboard/components/OverviewTab';
// // import styles from './Dashboard.module.css';
// // import OverviewTabWithSidebar from '../Components_Sidebar/OverviewTabWithSidebar';

// // const LandingPage = () => {
// //   const location = useLocation();
// //   const activeTab = location.state?.activeTab || "landing";

// //   const [sidebarOpen, setSidebarOpen] = useState(false);
// //   const [isMobile, setIsMobile] = useState(false);
// //   const canvasRef = useRef(null);

// //   /* ---------------- RESPONSIVE SIDEBAR ---------------- */
// //   useEffect(() => {
// //     const checkMobile = () => {
// //       const mobile = window.innerWidth < 1024;
// //       setIsMobile(mobile);
// //       setSidebarOpen(!mobile);
// //     };
// //     checkMobile();
// //     window.addEventListener('resize', checkMobile);
// //     return () => window.removeEventListener('resize', checkMobile);
// //   }, []);

// //   /* ---------------- BACKGROUND DOT ANIMATION ---------------- */
// //   useEffect(() => {
// //     const canvas = canvasRef.current;
// //     if (!canvas) return;
// //     const ctx = canvas.getContext('2d');
// //     let animationFrameId;

// //     const resizeCanvas = () => {
// //       canvas.width = window.innerWidth;
// //       canvas.height = window.innerHeight;
// //     };
// //     resizeCanvas();
// //     window.addEventListener('resize', resizeCanvas);

// //     const drawDots = () => {
// //       ctx.clearRect(0, 0, canvas.width, canvas.height);
// //       const spacing = 30;
// //       for (let x = 0; x < canvas.width; x += spacing) {
// //         for (let y = 0; y < canvas.height; y += spacing) {
// //           ctx.beginPath();
// //           ctx.arc(x, y, 1.5, 0, 2 * Math.PI);
// //           ctx.fillStyle = 'rgba(255,255,255,0.1)';
// //           ctx.fill();
// //         }
// //       }
// //       animationFrameId = requestAnimationFrame(drawDots);
// //     };

// //     drawDots();
// //     return () => {
// //       cancelAnimationFrame(animationFrameId);
// //       window.removeEventListener('resize', resizeCanvas);
// //     };
// //   }, []);

// //   const handleSidebarEnter = () => !isMobile && setSidebarOpen(true);
// //   const handleSidebarLeave = () => !isMobile && setSidebarOpen(false);

// //   const handleGetStartedClick = () => {
// //     setSidebarOpen(true);
// //   };

// //   return (
// //     <div className={styles.dashboardContainer}>
// //       {/* SIDEBAR */}
// //       <Sidebar
// //         isOpen={sidebarOpen}
// //         toggleSidebar={() => setSidebarOpen(prev => !prev)}
// //         onMouseEnter={handleSidebarEnter}
// //         onMouseLeave={handleSidebarLeave}
// //       />

// //       {/* MAIN CONTENT */}
// //       <main
// //         className={styles.mainContent}
// //         style={{ marginLeft: sidebarOpen ? '280px' : '80px' }}
// //       >
// //         {/* BACKGROUND */}
// //         <canvas
// //           ref={canvasRef}
// //           style={{
// //             position: 'absolute',
// //             inset: 0,
// //             width: '100%',
// //             height: '100%',
// //             pointerEvents: 'none',
// //             zIndex: 0,
// //           }}
// //         />

// //         <div className={styles.landingPage} style={{ position: 'relative', zIndex: 1 }}>

// //           {/* ================= LANDING ================= */}
// //           {activeTab === "landing" && (
// //             <>
// //               <div className={styles.leftContent}>
// //                 <div className={styles.titleContainer}>
// //                   <h1 className={styles.mainTitle}>
// //                     {'Welcome to Skillora'.split('').map((letter, index) => (
// //                       <span key={index} className={styles.letter}>
// //                         <span className={styles.glitchLayer}>{letter}</span>
// //                         <span className={styles.glitchLayer}>{letter}</span>
// //                         <span className={styles.letterInner}>
// //                           {letter === ' ' ? '\u00A0' : letter}
// //                         </span>
// //                       </span>
// //                     ))}
// //                   </h1>
// //                 </div>

// //                 <div className={styles.subtitle}>
// //                   <p className="mb-5">
// //                     <span className={styles.waveIcon}>🎯</span>
// //                     <span className={styles.waveText}>Revolutionizing</span>
// //                     <span className={styles.waveText}>Skill</span>
// //                     <span className={styles.waveText}>Assessment</span>
// //                   </p>
// //                 </div>

// //                 <button
// //                   className={styles.getStartedButton}
// //                   onClick={handleGetStartedClick}
// //                 >
// //                   <span className={styles.buttonText}>Get Started →</span>
// //                   <div className={styles.buttonBackground}></div>
// //                   <div className={styles.buttonBorder}></div>
// //                 </button>
// //               </div>

// //               {/* RIGHT CONTENT */}
// //               <div className={styles.rightContent}>
// //                 <div className={styles.imageContainer}>
// //                   <img
// //                     src="/images/Interview.jpg"
// //                     alt="Skill Assessment Interview"
// //                     className={styles.mainImage}
// //                   />
// //                   <div className={styles.imageOverlay}></div>
// //                   <div className={styles.floatingElement1}>⭐</div>
// //                   <div className={styles.floatingElement2}>💡</div>
// //                   <div className={styles.glowRing}></div>
// //                 </div>
// //               </div>
// //             </>
// //           )}

// //           {/* ================= OVERVIEW ================= */}
// //           {activeTab === "overview" && (
// //   <OverviewTabWithSidebar sidebarOpen={sidebarOpen} />
// // )}

// //           {/* ================= ANALYTICS ================= */}
// //           {activeTab === "analytics" && (
// //             <div style={{ padding: 24 }}>
// //               <h2>Analytics</h2>
// //               <p>Analytics content goes here</p>
// //             </div>
// //           )}

// //           {/* ================= LEADERBOARDS ================= */}
// //           {activeTab === "leaderboards" && (
// //             <div style={{ padding: 24 }}>
// //               <h2>Leaderboards</h2>
// //               <p>Leaderboard content goes here</p>
// //             </div>
// //           )}

// //         </div>
// //       </main>
// //     </div>
// //   );
// // };

// // export default LandingPage;
// // src/Temp/Dashboard/LandingPage.jsx


// // import React, { useState, useEffect, useRef } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import Sidebar from '../Sidebar/Sidebar';
// // import '../../css/Updatedstyles.css';

// // const LandingPage = () => {
// //   const location = useLocation();

// //   const getInitialTab = () => {
// //     return location.state?.activeTab ?? "landing";
// //   };

// //   const [activeTab, setActiveTab] = useState(getInitialTab());
// //   const [sidebarOpen, setSidebarOpen] = useState(false);
// //   const [isMobile, setIsMobile] = useState(false);
// //   const canvasRef = useRef(null);

// //   useEffect(() => {
// //     if (location.state?.activeTab) {
// //       setActiveTab(location.state.activeTab);
// //     }
// //   }, [location.state]);

// //   useEffect(() => {
// //     if (activeTab !== "landing") {
// //       sessionStorage.setItem('activeTab', activeTab);
// //     }
// //   }, [activeTab]);

// //   const handleTabChange = (tabName) => {
// //     setActiveTab(tabName);
// //     sessionStorage.setItem('activeTab', tabName);
// //   };

// //   const handleGetStartedClick = () => {
// //     setSidebarOpen(true);
// //     handleTabChange("overview");
// //   };

// //   useEffect(() => {
// //     const checkMobile = () => {
// //       const mobile = window.innerWidth < 1024;
// //       setIsMobile(mobile);
// //       setSidebarOpen(!mobile);
// //     };
// //     checkMobile();
// //     window.addEventListener('resize', checkMobile);
// //     return () => window.removeEventListener('resize', checkMobile);
// //   }, []);

// //   useEffect(() => {
// //     const canvas = canvasRef.current;
// //     if (!canvas) return;
// //     const ctx = canvas.getContext('2d');
// //     let animationFrameId;

// //     const resizeCanvas = () => {
// //       canvas.width = window.innerWidth;
// //       canvas.height = window.innerHeight;
// //     };
// //     resizeCanvas();
// //     window.addEventListener('resize', resizeCanvas);

// //     const drawDots = () => {
// //       ctx.clearRect(0, 0, canvas.width, canvas.height);
// //       const spacing = 30;
// //       for (let x = 0; x < canvas.width; x += spacing) {
// //         for (let y = 0; y < canvas.height; y += spacing) {
// //           ctx.beginPath();
// //           ctx.arc(x, y, 1.5, 0, 2 * Math.PI);
// //           ctx.fillStyle = 'rgba(255,255,255,0.1)';
// //           ctx.fill();
// //         }
// //       }
// //       animationFrameId = requestAnimationFrame(drawDots);
// //     };

// //     drawDots();
// //     return () => {
// //       cancelAnimationFrame(animationFrameId);
// //       window.removeEventListener('resize', resizeCanvas);
// //     };
// //   }, []);

// //   const handleSidebarEnter = () => !isMobile && setSidebarOpen(true);
// //   const handleSidebarLeave = () => !isMobile && setSidebarOpen(false);

// //   return (
// //     <div className="lp-dashboard-container">
// //       <Sidebar
// //         isOpen={sidebarOpen}
// //         toggleSidebar={() => setSidebarOpen(prev => !prev)}
// //         onMouseEnter={handleSidebarEnter}
// //         onMouseLeave={handleSidebarLeave}
// //       />

// //       <main
// //         className="lp-main-content"
// //         style={{ paddingLeft: sidebarOpen ? '230px' : '95px' }}
// //       >
// //         <canvas
// //           ref={canvasRef}
// //           className="lp-dot-grid-canvas"
// //         />

// //         <div className="lp-landing-page">
// //           {activeTab === "landing" && (
// //             <>
// //               <div className="lp-left-content">
// //                 <div className="lp-title-container">
// //                   <h1 className="lp-main-title">
// //                     {'Welcome to Skillora'.split('').map((letter, index) => (
// //                       <span key={index} className="lp-letter">
// //                         <span className="lp-glitch-layer">{letter}</span>
// //                         <span className="lp-glitch-layer">{letter}</span>
// //                         <span className="lp-letter-inner">
// //                           {letter === ' ' ? '\u00A0' : letter}
// //                         </span>
// //                       </span>
// //                     ))}
// //                   </h1>
// //                 </div>

// //                 <div className="lp-subtitle">
// //                   <p className="mb-5">
// //                     <span className="lp-wave-icon">🎯</span>
// //                     <span className="lp-wave-text">Revolutionizing</span>
// //                     <span className="lp-wave-text">Skill</span>
// //                     <span className="lp-wave-text">Assessment</span>
// //                   </p>
// //                 </div>
// //               </div>

// //               <div className="lp-right-content">
// //                 <div className="lp-image-container">
// //                   <img
// //                     src="/images/Interview.jpg"
// //                     alt="Skill Assessment Interview"
// //                     className="lp-main-image"
// //                   />
// //                   <div className="lp-image-overlay"></div>
// //                   <div className="lp-floating-element1">⭐</div>
// //                   <div className="lp-floating-element2">💡</div>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </main>
// //     </div>
// //   );
// // };

// // export default LandingPage;






// // LandingPage.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useOutletContext } from 'react-router-dom';
// import '../../css/ProfessionalLanding.css';

// const LandingPage = () => {
//   const navigate = useNavigate();
//   const { userRole } = useOutletContext();
//   const canvasRef = useRef(null);
//   const [isNavigating, setIsNavigating] = useState(false);

//   useEffect(() => {
//     console.log('LandingPage - User Role:', userRole);
//   }, [userRole]);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext('2d');
//     let animationFrameId;

//     const resizeCanvas = () => {
//       canvas.width = window.innerWidth;
//       canvas.height = window.innerHeight;
//     };
//     resizeCanvas();
//     window.addEventListener('resize', resizeCanvas);

//     const drawDots = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       const spacing = 40;
//       for (let x = 0; x < canvas.width; x += spacing) {
//         for (let y = 0; y < canvas.height; y += spacing) {
//           ctx.beginPath();
//           ctx.arc(x, y, 1.5, 0, 2 * Math.PI);
//           ctx.fillStyle = 'rgba(255,255,255,0.08)';
//           ctx.fill();
//         }
//       }
//       animationFrameId = requestAnimationFrame(drawDots);
//     };

//     drawDots();
//     return () => {
//       cancelAnimationFrame(animationFrameId);
//       window.removeEventListener('resize', resizeCanvas);
//     };
//   }, []);

//   const handleGetStartedClick = () => {
//     if (isNavigating) return;
    
//     setIsNavigating(true);
//     console.log('Get Started clicked. User role:', userRole);
    
//     // Clear any previous navigation errors
//     sessionStorage.removeItem('navigation_error');
    
//     // Use a small delay to ensure state updates
//     setTimeout(() => {
//       try {
//         if (userRole === "8") {
//           console.log('Navigating to /managers/dashboard/overview');
//           navigate("/managers/dashboard/overview", { replace: true });
//         } else if (userRole === "9") {
//           console.log('Navigating to /hr/dashboard/overview');
//           navigate("/hr/dashboard/overview", { replace: true });
//         } else if (userRole === "10") {
//           console.log('Navigating to /user/dashboard');
//           navigate("/user/dashboard", { replace: true });
//         } else {
//           console.log('No valid role, redirecting to /');
//           navigate("/", { replace: true });
//         }
//       } catch (error) {
//         console.error('Navigation error:', error);
//         // Fallback navigation
//         navigate("/", { replace: true });
//       } finally {
//         setIsNavigating(false);
//       }
//     }, 100);
//   };

//   return (
//     <div className="lp-dashboard-container">
//       <canvas ref={canvasRef} className="lp-dot-grid-canvas" />

//       <div className="lp-landing-page">
//         <div className="lp-left-content">
//           <div className="lp-title-container">
//             <h1 className="lp-main-title">Welcome to Skillora</h1>
//           </div>

//           <div className="lp-subtitle">
//             <p>
//               Empowering organizations with smarter skill assessment
//             </p>
//           </div>

//           <button 
//             className={`lp-cta-button ${isNavigating ? 'loading' : ''}`} 
//             onClick={handleGetStartedClick}
//             disabled={isNavigating || !userRole}
//           >
//             {isNavigating ? (
//               <>
//                 <span className="spinner-small"></span>
//                 Redirecting...
//               </>
//             ) : (
//               'Get Started'
//             )}
//           </button>
          
//           {/* Debug info - shows current role */}
//           {process.env.NODE_ENV === 'development' && (
//             <div className="debug-info">
//               <small>Current Role: {userRole || 'Loading...'}</small>
//             </div>
//           )}
//         </div>

//         <div className="lp-right-content">
//           <div className="lp-image-container">
//             <img
//               src="/images/Interview.jpg"
//               alt="Skill Assessment Interview"
//               className="lp-main-image"
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = "/images/placeholder-interview.jpg";
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LandingPage;


















import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import '../../css/ProfessionalLanding.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const userRole = sessionStorage.getItem("user_role");
  const canvasRef = useRef(null);
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    console.log('LandingPage - User Role:', userRole);
  }, [userRole]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const drawDots = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const spacing = 40;
      for (let x = 0; x < canvas.width; x += spacing) {
        for (let y = 0; y < canvas.height; y += spacing) {
          ctx.beginPath();
          ctx.arc(x, y, 1.5, 0, 2 * Math.PI);
          ctx.fillStyle = 'rgba(255,255,255,0.08)';
          ctx.fill();
        }
      }
      animationFrameId = requestAnimationFrame(drawDots);
    };

    drawDots();
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  const handleGetStartedClick = () => {
    if (isNavigating || !userRole) return;
    
    setIsNavigating(true);
    console.log('Get Started clicked. User role:', userRole);
    
    setTimeout(() => {
      try {
        if (userRole === "8") {
          console.log('Navigating to /managers/dashboard');
          navigate("/managers/dashboard", { replace: true });
        } else if (userRole === "9") {
          console.log('Navigating to /hr/dashboard/overview');
          navigate("/hr/dashboard/overview", { replace: true });
        } else if (userRole === "10") {
          console.log('Navigating to /user/dashboard');
          navigate("/user/dashboard", { replace: true });
        } else {
          console.log('No valid role, redirecting to /');
          // navigate("/", { replace: true });
        }
      } catch (error) {
        console.error('Navigation error:', error);
        // navigate("/", { replace: true });
        console.log("landing page");
      } finally {
        setIsNavigating(false);
      }
    }, 100);
  };

  if (!userRole) {
    return (
      <div className="lp-dashboard-container">
        <canvas ref={canvasRef} className="lp-dot-grid-canvas" />
        <div className="lp-landing-page">
          <div className="lp-left-content">
            <div className="lp-title-container">
              <h1 className="lp-main-title">Authentication Required</h1>
            </div>
            <div className="lp-subtitle">
              <p>Please log in to access the dashboard.</p>
            </div>
            <button 
              className="lp-cta-button" 
              // onClick={() => navigate("/")}
            >
             {console.log("landing page 22")} Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lp-dashboard-container">
      <canvas ref={canvasRef} className="lp-dot-grid-canvas" />

      <div className="lp-landing-page">
        <div className="lp-left-content">
          <div className="lp-title-container">
            <h1 className="lp-main-title">Welcome to Skillora</h1>
          </div>

          <div className="lp-subtitle">
            <p>
              Empowering organizations with smarter skill assessment
            </p>
          </div>

          <button 
            className={`lp-cta-button ${isNavigating ? 'loading' : ''}`} 
            onClick={handleGetStartedClick}
            disabled={isNavigating}
          >
            {isNavigating ? (
              <>
                <span className="spinner-small"></span>
                Redirecting...
              </>
            ) : (
              'Get Started'
            )}
          </button>
          
          
        </div>

        <div className="lp-right-content">
          <div className="lp-image-container">
            <img
              src="/images/Interview.jpg"
              alt="Skill Assessment Interview"
              className="lp-main-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholder-interview.jpg";
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;